module.exports = __webpack_public_path__ + "img/nbus_box_2-2.8015f2ac.jpg";